import { ReportResponse } from '../types/Report.types';
import apiBase from './ApiBase';

class ReportService {
  async getReport(questionnaireId: string): Promise<ReportResponse> {
    const response = await apiBase.get(
      `/questionnaire/report/${questionnaireId}`
    );
    return response.data;
  }
}

const reportService = new ReportService();
export default reportService;
